import FpMenuLoader from './FpMenuLoader.jsx'

class FpMenu {
  constructor () {
    this.FpMenuLoader = FpMenuLoader
    return this
  }
}
export default new FpMenu()
